"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.CancelBackorderDemandEvent = void 0;
const Name = exports.Name = 'cancel-backorder-demand';
const CancelBackorderDemandEvent = exports.CancelBackorderDemandEvent = Name;
//# sourceMappingURL=index.js.map